/*
 * @Author: wzh
 * @LastEditTime: 2022-11-28 14:51:12
 * @Description: Store
 */
import Vue from "vue";
import Vuex from "vuex";

import * as modules from "./modules";
import GlobalModule from "./global.store";

Vue.use(Vuex);

const store = new Vuex.Store({
	...GlobalModule,
	modules,
});

export default store;
